module.exports = "";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/products-list/templates/products-list-t4.view.html
 ** module id = 666
 ** module chunks = 7
 **/